/* Zeyna London — kleurbolletjes op basis van de échte kleur van de variant.
   Elk bolletje heeft data-zl-swatch="<url van de variantfoto>". Dit script leest de foto
   (klein, 64px breed) en bepaalt de kleur van het kledingstuk:
     1. alleen het middengebied van de foto (daar zit het kledingstuk);
     2. achtergrond eruit filteren (mediaan van de randpixels);
     3. pixels clusteren in Lab-kleurruimte; licht/schaduw van dezelfde stof samenvoegen;
     4. huid negeren als er een duidelijke kledingkleur naast staat;
     5. de kleurnaam wijst aan wélk deel van de foto het kledingstuk is (niet de kleur zelf);
     6. print (volgens titel/naam, of heel onrustige stof) → ingezoomd stukje stof i.p.v. één kleur.
   Resultaten worden per foto onthouden in localStorage, dus een tweede bezoek is direct. */
(function () {
  'use strict';
  if (window.ZLSwatch) return;

  var VERSION = 'v6'; // v6 (Sola): naam-vangnet, extra kleurnamen, 'X and Y' = tweekleurig
  var STORE_KEY = 'zl-swatch-' + VERSION;
  var cache = {};
  try { cache = JSON.parse(localStorage.getItem(STORE_KEY) || '{}') || {}; } catch (e) { cache = {}; }
  var saveT = null;

  function persist() {
    if (saveT) return;
    saveT = setTimeout(function () {
      saveT = null;
      try { localStorage.setItem(STORE_KEY, JSON.stringify(cache)); } catch (e) {}
    }, 400);
  }

  // ---- kleurwiskunde ------------------------------------------------------

  function lin(c) { c /= 255; return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); }
  function f(t) { return t > 0.008856 ? Math.cbrt(t) : 7.787 * t + 16 / 116; }

  function lab(r, g, b) {
    var R = lin(r), G = lin(g), B = lin(b);
    var x = (R * 0.4124 + G * 0.3576 + B * 0.1805) / 0.95047;
    var y = (R * 0.2126 + G * 0.7152 + B * 0.0722);
    var z = (R * 0.0193 + G * 0.1192 + B * 0.9505) / 1.08883;
    var fx = f(x), fy = f(y), fz = f(z);
    return [116 * fy - 16, 500 * (fx - fy), 200 * (fy - fz)];
  }

  function dE(p, q) {
    var a = p[0] - q[0], b = p[1] - q[1], c = p[2] - q[2];
    return Math.sqrt(a * a + b * b + c * c);
  }

  // Afstand waarbij lichtheid minder telt: licht en schaduw op dezelfde stof liggen dicht bij elkaar.
  function dShade(p, q) {
    var a = (p[0] - q[0]) * 0.35, b = p[1] - q[1], c = p[2] - q[2];
    return Math.sqrt(a * a + b * b + c * c);
  }

  function dAB(p, q) {
    var b = p[1] - q[1], c = p[2] - q[2];
    return Math.sqrt(b * b + c * c);
  }

  function isSkin(l) {
    var C = Math.sqrt(l[1] * l[1] + l[2] * l[2]);
    var h = Math.atan2(l[2], l[1]) * 180 / Math.PI;
    return l[0] > 35 && l[0] < 88 && C > 9 && C < 42 && h > 28 && h < 72;
  }

  function hex(r, g, b) {
    return '#' + [r, g, b].map(function (v) {
      v = Math.max(0, Math.min(255, Math.round(v)));
      return (v < 16 ? '0' : '') + v.toString(16);
    }).join('');
  }

  function median(arr) {
    var s = arr.slice().sort(function (a, b) { return a - b; });
    return s[Math.floor(s.length / 2)];
  }

  // ---- kleurnaam als wegwijzer ---------------------------------------------
  // De naam bepaalt NIET de kleur van het bolletje; hij wijst alleen aan wélk deel van de
  // foto het kledingstuk is (bijv. 'Violet' = de paarse jas, niet het zwarte shirt eronder).
  // Het bolletje krijgt daarna de echte tint uit de foto. Alleen als meerdere kleuren exact
  // dezelfde foto delen (de foto zegt dan niets) valt het terug op deze richtkleur.
  var NAMED = {
    'black': '#141414', 'jet': '#141414', 'white': '#f4f3ef', 'ivory': '#f1ecdf', 'cream': '#ede3cf',
    'creme': '#ede3cf', 'milky': '#efe9dd', 'off white': '#ece7dc', 'snow': '#f6f6f4', 'beige': '#d8c6a6',
    'nude': '#d9b49b', 'sand': '#d5c19f', 'stone': '#c9c0b0', 'oat': '#dccfb7', 'camel': '#b98b5a',
    'khaki': '#b5a47c', 'tan': '#c09a6c', 'taupe': '#8f7f72', 'brown': '#6b4a33', 'coffee': '#5b3f2c',
    'chocolate': '#4a2e20', 'mocha': '#6f5143', 'cognac': '#9a5a2e', 'caramel': '#b4763a', 'rust': '#a4492b',
    'apricot': '#efb58c', 'peach': '#f3b99c', 'coral': '#ef7d64', 'orange': '#e7742b', 'mustard': '#d2a22b',
    'yellow': '#eecf48', 'lemon': '#f2e36c', 'butter': '#f1e2a2', 'gold': '#c8a44b', 'champagne': '#e5d2b3',
    'silver': '#c0c0c4', 'grey': '#8d8d8d', 'gray': '#8d8d8d', 'charcoal': '#3e3e40', 'red': '#c8202b',
    'wine': '#6d1a2a', 'burgundy': '#6c1a2c', 'maroon': '#5e1a22', 'bordeaux': '#5e1a28', 'claret': '#7a1f30',
    'pink': '#efa6b7', 'blush': '#f1c4c4', 'rose': '#d8858f', 'fuchsia': '#d5337a', 'magenta': '#c1307f',
    'hot pink': '#ee4a8a', 'purple': '#7d4a9a', 'lilac': '#c7a8d8', 'lila': '#c7a8d8', 'lavender': '#b9a6db',
    'violet': '#7f4fa6', 'plum': '#5d2e4a', 'mauve': '#b07f96', 'blue': '#2f5fb3', 'light blue': '#a9c8e8',
    'sky blue': '#8ec0e8', 'baby blue': '#b8d4ee', 'royal blue': '#2345b0', 'royal': '#2345b0', 'navy': '#1f2a4a',
    'denim': '#4f6d8f', 'teal': '#1f6f73', 'turquoise': '#3bb7b0', 'aqua': '#7fd3cf', 'mint': '#a8dcc0',
    'green': '#3f7a3f', 'sage': '#9fae8c', 'olive': '#6b6a35', 'army': '#4b5534', 'emerald': '#1f6b4a',
    'moss': '#6a7040', 'dark green': '#1f4a2e', 'light green': '#9ccf8a', 'forest': '#24452e', 'bottle': '#1d4a36',
    // Sola: namen uit de catalogus die hierboven ontbraken (o.a. Duitse leveranciersnamen)
    'darkbrown': '#3e2a1e', 'chestnut': '#7b3f2a', 'terracotta': '#c0603f', 'golden': '#c8a44b', 'cherry': '#9e1b32',
    'crimson': '#b01e35', 'matcha': '#a4b86a', 'khakifarben': '#b5a47c', 'gelb': '#eecf48',
    'armeegr': '#4b5534', 'erbsengr': '#9dc08b'
  };
  var NAMED_KEYS = Object.keys(NAMED).sort(function (a, b) { return b.length - a.length; });

  function nameTarget(name) {
    var n = ' ' + String(name || '').toLowerCase().replace(/[^a-z ]+/g, ' ').replace(/\s+/g, ' ') + ' ';
    for (var i = 0; i < NAMED_KEYS.length; i++) {
      var k = NAMED_KEYS[i];
      if (n.indexOf(' ' + k + ' ') > -1) {
        var h = NAMED[k];
        var t = lab(parseInt(h.substr(1, 2), 16), parseInt(h.substr(3, 2), 16), parseInt(h.substr(5, 2), 16));
        if (/ (light|pale|baby|soft) /.test(n) && k.indexOf('light') < 0 && k.indexOf('baby') < 0) t[0] = Math.min(96, t[0] + 18);
        if (/ (dark|deep) /.test(n) && k.indexOf('dark') < 0) t[0] = Math.max(8, t[0] - 18);
        return { l: t, hex: h };
      }
    }
    return null;
  }

  function chroma(l) { return Math.sqrt(l[1] * l[1] + l[2] * l[2]); }
  function hue(l) { var h = Math.atan2(l[2], l[1]) * 180 / Math.PI; return h < 0 ? h + 360 : h; }
  function hueDiff(p, q) { var d = Math.abs(hue(p) - hue(q)) % 360; return d > 180 ? 360 - d : d; }

  // ---- analyse ------------------------------------------------------------

  function kmeans(pts, k) {
    // Deterministische start: pixels verdeeld over de lichtheid.
    var sorted = pts.slice().sort(function (a, b) { return a.l[0] - b.l[0]; });
    var cs = [];
    for (var i = 0; i < k; i++) cs.push(sorted[Math.floor((i + 0.5) * sorted.length / k)].l.slice());
    var assign = new Array(pts.length);
    for (var it = 0; it < 10; it++) {
      var sum = cs.map(function () { return [0, 0, 0, 0]; });
      for (var p = 0; p < pts.length; p++) {
        var best = 0, bd = Infinity;
        for (var c = 0; c < k; c++) {
          var d = dE(pts[p].l, cs[c]);
          if (d < bd) { bd = d; best = c; }
        }
        assign[p] = best;
        var s = sum[best]; s[0] += pts[p].l[0]; s[1] += pts[p].l[1]; s[2] += pts[p].l[2]; s[3]++;
      }
      for (c = 0; c < k; c++) if (sum[c][3]) cs[c] = [sum[c][0] / sum[c][3], sum[c][1] / sum[c][3], sum[c][2] / sum[c][3]];
    }
    var groups = cs.map(function (c) { return { l: c, px: [] }; });
    for (p = 0; p < pts.length; p++) groups[assign[p]].px.push(pts[p]);
    return groups.filter(function (g) { return g.px.length; });
  }

  function centre(g) {
    var L = 0, A = 0, B = 0;
    g.px.forEach(function (p) { L += p.l[0]; A += p.l[1]; B += p.l[2]; });
    var n = g.px.length;
    g.l = [L / n, A / n, B / n];
  }

  // Grootste kleurgroep (licht/schaduw samengevoegd), aflopend gesorteerd.
  function clusterGroups(pts) {
    var groups = kmeans(pts, 5);
    groups.forEach(centre);
    var merged = true;
    while (merged && groups.length > 1) {
      merged = false;
      var bi = -1, bj = -1, bd = 14;
      for (var i = 0; i < groups.length; i++) for (var j = i + 1; j < groups.length; j++) {
        var dd = dShade(groups[i].l, groups[j].l);
        if (dd < bd) { bd = dd; bi = i; bj = j; }
      }
      if (bi > -1) {
        groups[bi].px = groups[bi].px.concat(groups[bj].px);
        groups.splice(bj, 1);
        centre(groups[bi]);
        merged = true;
      }
    }
    groups.sort(function (a, b) { return b.px.length - a.px.length; });
    return groups;
  }

  // Waargenomen tint van de stof: diepe schaduwen (plooien, fluweel, satijn) en glimlichten
  // eruit (40–90% op lichtheid), en daarvan de verzadigde helft — zo zie je een kleur echt.
  function toneHex(px) {
    var s = px.slice().sort(function (a, b) { return a.l[0] - b.l[0]; });
    var band = s.slice(Math.floor(s.length * 0.4), Math.max(Math.floor(s.length * 0.4) + 1, Math.ceil(s.length * 0.9)));
    band.sort(function (a, b) { return chroma(b.l) - chroma(a.l); });
    band = band.slice(0, Math.max(1, Math.ceil(band.length / 2)));
    var r = 0, g = 0, b = 0;
    band.forEach(function (p) { r += p.r; g += p.g; b += p.b; });
    return hex(r / band.length, g / band.length, b / band.length);
  }

  function analyze(img, name, debug) {
    var W = 64;
    var H = Math.max(8, Math.round(W * img.naturalHeight / img.naturalWidth));
    var cv = document.createElement('canvas');
    cv.width = W; cv.height = H;
    var ctx = cv.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, W, H);
    var d = ctx.getImageData(0, 0, W, H).data;

    function px(x, y) {
      var i = (y * W + x) * 4;
      return { r: d[i], g: d[i + 1], b: d[i + 2], x: x / W, y: y / H, l: lab(d[i], d[i + 1], d[i + 2]) };
    }

    // Achtergrond: mediaan van de randpixels.
    var bL = [], bA = [], bB = [];
    for (var y = 0; y < H; y++) for (var x = 0; x < W; x++) {
      if (x > 1 && x < W - 2 && y > 1 && y < H - 2) continue;
      var e = px(x, y); bL.push(e.l[0]); bA.push(e.l[1]); bB.push(e.l[2]);
    }
    var bg = [median(bL), median(bA), median(bB)];

    // Middengebied: bij staande foto's romp/heupen (waar het kledingstuk zeker zit),
    // bij vierkante productfoto's gewoon het midden.
    var portrait = H > W * 1.1;
    var x0 = Math.floor(W * 0.33), x1 = Math.ceil(W * 0.67);
    var y0 = Math.floor(H * (portrait ? 0.22 : 0.28)), y1 = Math.ceil(H * (portrait ? 0.6 : 0.72));
    var roi = [];
    for (y = y0; y < y1; y++) for (x = x0; x < x1; x++) roi.push(px(x, y));

    // Drukte van de stof: aandeel buurpixels met een scherpe kleursprong. Effen stof met
    // plooien/glans verloopt geleidelijk; een print springt steeds heen en weer.
    var jumps = 0, pairs = 0;
    var cx0 = Math.floor(W * 0.38), cx1 = Math.ceil(W * 0.62);
    for (y = y0; y < y1 - 1; y++) for (x = cx0; x < cx1 - 1; x++) {
      var a0 = px(x, y).l;
      if (dE(a0, px(x + 1, y).l) > 16) jumps++;
      if (dE(a0, px(x, y + 1).l) > 16) jumps++;
      pairs += 2;
    }
    var busy = jumps / pairs;

    // Kandidaten: (A) kleurgroepen na achtergrondfilter; (B) smalle strook midden over de romp
    // zonder filter — voor kleding die op de achtergrond lijkt (wit/crème/pastel).
    var fgA = roi.filter(function (p) { return dE(p.l, bg) > 14; });
    var strip = roi.filter(function (p) { return p.x >= 0.42 && p.x <= 0.58; });
    var nonSkin = fgA.filter(function (p) { return !isSkin(p.l); }).length;
    var light = nonSkin < roi.length * 0.3;
    var groupsA = fgA.length >= roi.length * 0.05 ? clusterGroups(fgA) : [];
    var groupsB = clusterGroups(strip);
    groupsA.forEach(function (g) { g.share = g.px.length / fgA.length; });
    groupsB.forEach(function (g) { g.share = g.px.length / strip.length; });
    var base = light || !groupsA.length ? groupsB : groupsA;

    function side(g) {
      var t = 0; g.px.forEach(function (p) { t += Math.abs(p.x - 0.5); }); return t / g.px.length;
    }

    var top = null, how = 'rules', print = false, i;

    // 1. Kleurnaam als wegwijzer: de naam bepaalt alleen de kleurfamilie (tint), niet hoe licht
    //    of fel. Binnen die familie wint het grootste vlak — dat is het kledingstuk.
    var target = nameTarget(name);
    if (target) {
      var tC = chroma(target.l), th = hue(target.l);
      var skinOk = isSkin(target.l) || (tC < 40 && th > 25 && th < 95); // beige/camel/khaki/bruin lijken op huid
      var best = null;
      groupsA.concat(groupsB).forEach(function (g) {
        if (g.share < 0.1 || (!skinOk && isSkin(g.l))) return;
        var ok = tC < 12
          ? chroma(g.l) < 16 && Math.abs(g.l[0] - target.l[0]) <= 28        // zwart/wit/grijs/crème
          : chroma(g.l) >= 7 && hueDiff(g.l, target.l) <= 35;                // zelfde kleurfamilie
        if (ok && (!best || g.share > best.share)) best = g;
      });
      if (best) { top = best; how = 'name'; }
    }

    // 2. Zonder bruikbare naam: regels.
    if (!top) {
      var cands = base.filter(function (g) { return !isSkin(g.l) && g.share >= 0.15; });
      if (light || !cands.length) {
        top = base[0];
      } else if (cands.length === 1) {
        top = cands[0];
      } else {
        var c1 = cands[0], c2 = cands[1];
        var ch1 = chroma(c1.l), ch2 = chroma(c2.l);
        if (ch1 >= 18 && ch2 >= 18 && dAB(c1.l, c2.l) > 25 && c2.share >= 0.25) print = true;       // twee flinke, verschillende kleuren
        else if (ch1 >= 18 && ch2 < 10) top = c1;                                                 // gekleurde jas over zwart/wit
        else if (ch2 >= 18 && ch1 < 10) top = c2;
        else if (ch1 < 10 && ch2 < 10) top = side(c1) >= side(c2) ? c1 : c2;                      // neutraal/neutraal: buitenste kledingstuk
        else top = c1;
      }
    }
    if (!top) top = base[0];

    // 3. Heel onrustige stof = print (tenzij de naam een duidelijke effen kleur aanwees).
    if (busy > 0.33 && how !== 'name') print = true;

    // 4. Sola-vangnet: de naam wijst een kleur aan, maar die familie zit niet (groot genoeg) in de foto
    //    en de regels pakken iets heel anders (spijkerbroek onder een laars, huid, achtergrond, of een
    //    foto die een andere kleur toont dan de naam). Dan de kleur van de naam tonen, net als bij één
    //    foto voor meerdere kleuren: de klant kiest op naam.
    //    Bewust smal (anders verdwijnen echte tinten als olijf/antraciet/pastel):
    //    - gekleurde naam, gekozen kleur is een héél andere kleurfamilie (tint > 90° ernaast),
    //      of een donkere neutrale vlek terwijl de naam veel lichter is (bv. roze trui → donkere bloemen);
    //    - 'Black' maar er is iets lichts gekozen; 'White' maar er is iets duidelijk gekleurds gekozen.
    //    Namen met 'with' ('Navy with White Letters') niet: daar is de eerste kleur de hoofdkleur.
    var byName = false;
    if (target && how !== 'name' && !print && !/\bwith\b/i.test(name || '')) {
      var tc = chroma(target.l), pc = chroma(top.l);
      if (tc >= 12) byName = (pc >= 12 && hueDiff(top.l, target.l) > 90) || (pc < 12 && tc >= 25 && target.l[0] - top.l[0] > 35);
      else if (target.l[0] < 20) byName = top.l[0] > 40;
      else if (target.l[0] > 90) byName = pc > 20;
    }

    var sx = 0, sy = 0, src = light || !fgA.length ? strip : fgA;
    src.forEach(function (p) { sx += p.x; sy += p.y; });
    var xy = [Math.round(sx / src.length * 100), Math.round(sy / src.length * 100)];
    var tonePx = top.px;
    if (!isSkin(top.l)) {
      var noSkin = top.px.filter(function (p) { return !isSkin(p.l); });
      if (noSkin.length >= top.px.length * 0.3) tonePx = noSkin;
    }
    var res = print ? { p: xy } : { c: byName ? target.hex : toneHex(tonePx), xy: xy };
    if (byName) how = 'name-fallback';
    if (target) res.t = target.hex;
    if (debug) res.d = { busy: +busy.toFixed(3), light: light, how: how };
    return res;
  }

  // Kleurnaam zegt al dat het een print/tweekleurig is (bijv. 'Leopard Print', 'Floral 2',
  // 'Blue & Purple', 'Brown/White'): dan altijd een stukje stof tonen.
  var PRINT_NAME = /print|floral|flower|leopard|jaguar|zebra|snake|tiger|animal|polka|dots?\b|stripe|check|plaid|gingham|paisley|abstract|colou?rful|multi|pattern|tie.?dye|camo|&|\/|\band\b/i;

  // forcePrint: de producttitel zegt dat het een print is (Floral, Leopard, …) → alle kleuren
  // van dat product consequent als stukje stof.
  function decide(res, name, forcePrint) {
    if (res && res.c && (forcePrint || (name && PRINT_NAME.test(name)))) return { p: res.xy || [50, 42] };
    return res;
  }

  // ---- toepassen op de bolletjes ------------------------------------------

  function keyOf(url, name) {
    return String(url).replace(/^https?:/, '').replace(/[?&]width=\d+/, '') + '|' + String(name || '').toLowerCase();
  }

  function absUrl(url) {
    return url.indexOf('//') === 0 ? location.protocol + url : url;
  }

  function apply(el, res, url) {
    if (res.c) {
      el.style.setProperty('--zl-sw-color', res.c);
      el.classList.add('is-solid');
    } else if (res.p) {
      el.style.setProperty('--zl-sw-img', 'url("' + url + '")');
      el.style.setProperty('--zl-sw-pos', res.p[0] + '% ' + res.p[1] + '%');
      el.classList.add('is-print');
    }
    el.classList.add('is-ready');
  }

  // Deelt deze kleur exact dezelfde foto met een andere kleur van hetzelfde product?
  // Dan zegt de foto niets over deze kleur en gebruiken we de richtkleur van de naam.
  function sharedPhoto(el) {
    var group = el.closest('[data-zl-swatch-group]');
    if (!group) return false;
    var url = el.getAttribute('data-zl-swatch');
    var same = group.querySelectorAll('[data-zl-swatch="' + (window.CSS && CSS.escape ? CSS.escape(url) : url) + '"]');
    return same.length > 1;
  }

  function processEl(el) {
    if (el.__zlSw) return;
    el.__zlSw = true;
    var raw = el.getAttribute('data-zl-swatch');
    if (!raw) return;
    var url = absUrl(raw);
    var name = el.getAttribute('data-zl-swatch-name') || '';
    var forcePrint = el.getAttribute('data-zl-swatch-print') === '1';

    if (sharedPhoto(el)) {
      var t = nameTarget(name);
      if (t && !forcePrint && !PRINT_NAME.test(name)) { apply(el, { c: t.hex }, url); return; }
    }

    var key = keyOf(url, name);
    if (cache[key]) { apply(el, decide(cache[key], name, forcePrint), url); return; }
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.decoding = 'async';
    img.onload = function () {
      var res;
      try { res = analyze(img, name); } catch (e) { res = { p: [50, 45] }; }
      delete res.d;
      cache[key] = res;
      persist();
      apply(el, decide(res, name, forcePrint), url);
    };
    img.onerror = function () { el.classList.add('is-ready'); };
    img.src = url;
  }

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { io.unobserve(en.target); processEl(en.target); }
        });
      }, { rootMargin: '300px' })
    : null;

  function scan(root) {
    var els = (root || document).querySelectorAll('[data-zl-swatch]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.__zlSw || el.__zlSwQ) continue;
      var key = keyOf(absUrl(el.getAttribute('data-zl-swatch') || ''), el.getAttribute('data-zl-swatch-name'));
      if (cache[key] || !io) { processEl(el); } else { el.__zlSwQ = true; io.observe(el); }
    }
  }

  window.ZLSwatch = { analyze: analyze, decide: decide, nameTarget: nameTarget, scan: scan, version: VERSION };

  function start() {
    scan(document);
    // Nieuwe kaarten/secties (filters, aanbevelingen) oppikken, en bolletjes waarvan het thema
    // bij een variantwissel de class/style heeft teruggezet (morph) opnieuw kleuren (uit cache).
    var t = null;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'attributes') {
          var el = m.target;
          if (el.hasAttribute && el.hasAttribute('data-zl-swatch') && el.__zlSw && !el.classList.contains('is-ready')) {
            el.__zlSw = false;
            processEl(el);
          }
        } else if (m.addedNodes.length && !t) {
          t = setTimeout(function () { t = null; scan(document); }, 60);
        }
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
